<template>
  <div class="menuEditor">
    <Form
      :model="formData"
      ref="menuEditor"
      :rules="formRules"
      :label-width="80"
    >
      <FormItem label="菜单名称" prop="title">
        <i-input v-model="formData.title" />
      </FormItem>
      <FormItem label="菜单图标" prop="icon">
        <CIconPicker
          :options="iconOptions"
          v-model="formData.icon"
        ></CIconPicker>
      </FormItem>
      <FormItem label="二级菜单" prop="children">
        <Select v-model="formData.children" multiple>
          <template v-for="menu in $store.state.main.menus.alternative">
            <OptionGroup
              :key="menu.id"
              :label="menu.title"
              v-if="menu.type !== 'custom'"
            >
              <template v-if="menu.children && menu.children.length > 0">
                <Option
                  v-for="subMenu in menu.children"
                  :value="subMenu.id"
                  :key="subMenu.id"
                  :disabled="subMenu.disabledForSelect"
                  >{{ subMenu.title }}</Option
                >
              </template>
              <Option
                v-else
                :value="menu.id"
                :disabled="menu.disabledForSelect"
                >{{ menu.title }}</Option
              >
            </OptionGroup>
          </template>
        </Select>
      </FormItem>
    </Form>
    <div class="cmsc-drawer-footer">
      <Button class="handle-item" @click="cancel">取消</Button>
      <Button type="primary" class="handle-item" @click="save">保存</Button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'menuEditor',
  props: ['data'],
  data() {
    return {
      iconOptions: [
        'caidan-shouye',
        'caidan-duanxinguanli',
        'caidan-zhishiku1',
        'caidan-jiechuguanli',
        'caidan-jichushezhi',
        'caidan-zidingyichangyong5',
        'caidan-waibozhongxin',
        'caidan-yunyingguanli',
        'caidan-zidingyichangyong4',
        'caidan-zaixiankefu',
        'caidan-zidingyichangyong3',
        'caidan-zidingyichangyong2',
        'caidan-zidingyichangyong1',
        'caidan-zidingyichangyong',
        'caidan-tongjibaobiao',
        'caidan-gongzuotai',
        'caidan-shilianxiufu',
        'caidan-kehuguanli',
        'caidan-yewuduixiangguanli',
        'caidan-qiyejibenxinxi',
        'caidan-gongdanguanli',
        'caidan-jichugongneng',
        'caidan-jiankongzhongxin',
        'caidan-bumenyonghuguanli',
        'caidan-AIhuashumobanpeizhi',
        'caidan-AItongjifenxi'
      ],
      formData: {
        id: '',
        title: '',
        icon: '',
        children: []
      },
      formRules: {
        title: [
          {
            required: true,
            message: '请输入菜单名称'
          },
          {
            pattern: /^[\u4e00-\u9fa5A-Za-z0-9]+$/g,
            message: '菜单名称不允许输入特殊字符'
          },
          {
            validator(rule, value) {
              /*eslint no-control-regex: "off"*/
              const _value = value.replace(/[^\x00-\xff]/g, 'aa')
              return _value.length <= 16
            },
            message: '菜单名称请输入16个字符以内'
          }
        ],
        icon: {
          required: true,
          trigger: 'change',
          message: '菜单图标不能为空'
        }
      }
    }
  },
  watch: {
    data: {
      handler(newValue) {
        if (newValue) {
          this.formData.id = newValue.id
          this.formData.title = newValue.title
          this.formData.icon = newValue.icon
          newValue.children.forEach(subMenu => {
            this.formData.children.push(subMenu.menuId)
          })
        } else {
          this.resetMenuEditor()
        }
      }
    },
    'formData.children'(newValue) {
      const setMenuDisabled = bool => {
        this.$store.state.main.menus.alternative.forEach(menu => {
          if (menu.type !== 'custom') {
            // 过滤掉自定义菜单
            if (menu.children && menu.children.length > 0) {
              menu.children.forEach(_menu => {
                if (!newValue.find(id => id === _menu.id))
                  this.$set(_menu, 'disabledForSelect', bool)
              })
            } else {
              if (!newValue.find(id => id === menu.id))
                this.$set(menu, 'disabledForSelect', bool)
            }
          }
        })
      }
      if (newValue.length === 10) {
        setMenuDisabled(true)
      } else {
        setMenuDisabled(false)
      }
    }
  },
  methods: {
    save() {
      this.$refs.menuEditor.validate(result => {
        if (result) {
          const formData = {
            title: this.formData.title,
            icon: this.formData.icon,
            children: this.formData.children
          }
          const onSuccess = (data, message) => {
            this.$emit('on-saved', {
              id: data.bean.menuId,
              title: data.bean.menuName,
              icon: data.bean.iconUrl,
              type: 'custom',
              children: this.getMenuDataByMenuId(
                data.bean.leafMenuId.split(',')
              )
            })
            this.$Message.success(message)
            this.resetMenuEditor()
          }
          if (this.formData.id) {
            this.$http
              .put(`/sctm/menu/customMenu/${this.formData.id}`, formData)
              .then(({ data }) => {
                onSuccess(data, '修改菜单成功')
              })
          } else {
            this.$http
              .post('/sctm/menu/customMenu', formData)
              .then(({ data }) => {
                onSuccess(data, '新建菜单成功')
              })
          }
        }
      })
    },
    cancel() {
      this.$emit('on-cancel')
    },
    getMenuDataByMenuId(menuIds) {
      let menuChildren = []
      menuIds.forEach(id => {
        this.$_.forEach(this.$store.state.main.menus.alternative, menu => {
          let menuData
          if (menu.children && menu.children.length > 0) {
            menuData = menu.children.find(subMenu => {
              return subMenu.id === id
            })
          } else {
            if (id === menu.id) menuData = menu
          }
          if (menuData) {
            menuData._disabled = false
            menuChildren.push(menuData)
            return false
          }
        })
      })
      return menuChildren
    },
    resetMenuEditor() {
      this.$refs.menuEditor.resetFields()
      this.formData.id = null
      this.formData.children = []
    }
  }
}
</script>
<style lang="stylus">
.menuEditor
  position relative
  height 100%

  .ivu-select-group
    display flex
    flex-wrap wrap

    .ivu-select-item
      width 0
      flex 0 0 50%
      margin 5px 0
</style>